import { h } from 'preact';
import BackLiveIcon from './icon-components/BackLiveIcon';
import { Chat } from './icon-components/Chat';
import { ChatActive } from './icon-components/ChatActive';
import CloseIcon from './icon-components/CloseIcon';
import EcoActiveIcon from './icon-components/EcoActiveIcon';
import EcoIcon from './icon-components/EcoIcon';
import EmbedIcon from './icon-components/EmbedIcon';
import EyeLiveIcon from './icon-components/EyeLiveIcon';
import FullscreenOffIcon from '../../../../../common/components/svg/icons/icon-components/FullscreenOff';
import FullscreenOnIcon from '../../../../../common/components/svg/icons/icon-components/FullscreenOn';
import PipIcon from './icon-components/PipIcon';
import PlaylistActiveIcon from './icon-components/PlaylistActiveIcon';
import PlaylistIcon from './icon-components/PlaylistIcon';
import { RemoteControl } from './icon-components/RemoteControl';
import { RemoteControlActive } from './icon-components/RemoteControlActive';
import SettingsIcon from './icon-components/SettingsIcon';
import { Star } from './icon-components/Star';
import { StarActive } from './icon-components/StarActive';
import TracksActiveIcon from './icon-components/TracksActiveIcon';
import TracksIcon from './icon-components/TracksIcon';
import VolumeLowIcon from '../../../../../common/components/svg/icons/icon-components/VolumeLowIcon';
import VolumeMaxIcon from '../../../../../common/components/svg/icons/icon-components/VolumeMaxIcon';
import VolumeModerateIcon from '../../../../../common/components/svg/icons/icon-components/VolumeModerateIcon';
import VolumeMuteIcon from '../../../../../common/components/svg/icons/icon-components/VolumeMuteIcon';

export const STANDARD_ICONS = (props) => ({
  tracks: <TracksIcon {...props} />,
  'tracks-active': <TracksActiveIcon {...props} />,
  pip: <PipIcon {...props} />,
  'fullscreen-off': <FullscreenOffIcon {...props} />,
  'fullscreen-on': <FullscreenOnIcon {...props} />,
  embed: <EmbedIcon {...props} />,
  eco: <EcoIcon {...props} />,
  'eco-activated': <EcoActiveIcon {...props} />,
  settings: <SettingsIcon {...props} />,
  'volume-mute': <VolumeMuteIcon {...props} />,
  'volume-low': <VolumeLowIcon {...props} />,
  'volume-moderate': <VolumeModerateIcon {...props} />,
  'volume-max': <VolumeMaxIcon {...props} />,
  'eye-live': <EyeLiveIcon {...props} />,
  'back-to-live': <BackLiveIcon {...props} />,
  close: <CloseIcon {...props} />,
  remoteControl: <RemoteControl {...props} />,
  remoteControlActive: <RemoteControlActive {...props} />,
  star: <Star {...props} />,
  starActive: <StarActive {...props} />,
  chat: <Chat {...props} />,
  chatActive: <ChatActive {...props} />,
  playlist: <PlaylistIcon {...props} />,
  'playlist-active': <PlaylistActiveIcon {...props} />
});
